import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { ArticleDto } from "../../../models/article/dto/article.dto";

export const GET_ARTICLE_QUERY_KEY = (id: string) => ['article', id];
export const useGetArticle = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_ARTICLE_QUERY_KEY(id),
        queryFn: () => client.fetchApi<ArticleDto, {}>({ endpoint: `articles/admin/${id}`, method: 'GET' }),
        enabled: !!id,
    });
};
